import { create } from 'zustand';
import { mountStoreDevtool } from 'simple-zustand-devtools';

const useAuthStore = create((set, get) => ({
    allUserData: null,
    loading: false,

    user: () => ({
        user_id: get().allUserData?.user_id || null,
        username: get().allUserData?.username || null,
    }),
    setUser: (user) => set({ allUserData: user }),
    setLoading: (loading) => set({ loading }),
    
    isLoggedIn: () => get().allUserData !== null,
}))

// if(import.meta.env.DEV){
//     mountStoreDevtool('winefacts', useAuthStore)
// }
if (import.meta.env.DEV && !window.__ZUSTAND_DEVTOOLS_MOUNTED__) {
    mountStoreDevtool('winefacts', useAuthStore);
    window.__ZUSTAND_DEVTOOLS_MOUNTED__ = true;
}

export { useAuthStore }